import Icon from '../../../components/AppIcon';

const ServiceAreaMap = () => {
  const serviceAreas = [
    {
      region: "Johannesburg",
      coverage: "Complete",
      responseTime: "30-45 min",
      icon: "MapPin",
      coordinates: { lat: -26.2041, lng: 28.0473 }
    },
    {
      region: "Pretoria",
      coverage: "Complete",
      responseTime: "30-45 min",
      icon: "MapPin",
      coordinates: { lat: -25.7479, lng: 28.2293 }
    },
    {
      region: "Cape Town",
      coverage: "Complete",
      responseTime: "45-60 min",
      icon: "MapPin",
      coordinates: { lat: -33.9249, lng: 18.4241 }
    },
    {
      region: "Durban",
      coverage: "Complete",
      responseTime: "45-60 min",
      icon: "MapPin",
      coordinates: { lat: -29.8587, lng: 31.0218 }
    }
  ];

  const handleEmergencyCall = () => {
    window.location.href = 'tel:0827935785';
  };

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="font-headline font-bold text-2xl md:text-3xl lg:text-4xl text-foreground mb-4">
            Service Area Coverage
          </h2>
          <p className="font-body text-base md:text-lg text-muted-foreground max-w-3xl mx-auto">
            Serving major metropolitan areas across South Africa with rapid emergency response and scheduled service appointments.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-start">
          <div className="bg-card border border-border rounded-2xl overflow-hidden shadow-elevated">
            <div className="aspect-[4/3] w-full">
              <iframe
                width="100%"
                height="100%"
                loading="lazy"
                title="meriodine Service Areas"
                referrerPolicy="no-referrer-when-downgrade"
                src="https://www.google.com/maps?q=-26.2041,28.0473&z=6&output=embed"
                className="w-full h-full"
              />
            </div>
          </div>

          <div className="space-y-6">
            <div className="bg-card border border-border rounded-xl p-6 md:p-8">
              <h3 className="font-headline font-semibold text-xl text-foreground mb-6">
                Coverage Areas
              </h3>
              <div className="space-y-4">
                {serviceAreas?.map((area, index) => (
                  <div
                    key={index}
                    className="flex items-center justify-between p-4 bg-muted rounded-lg hover:bg-primary/5 transition-colors"
                  >
                    <div className="flex items-center gap-3">
                      <div className="flex items-center justify-center w-10 h-10 rounded-full bg-primary/10">
                        <Icon name={area?.icon} size={20} color="var(--color-primary)" />
                      </div>
                      <div>
                        <h4 className="font-headline font-semibold text-base text-foreground">
                          {area?.region}
                        </h4>
                        <p className="font-body text-xs text-muted-foreground">
                          {area?.coverage} Coverage
                        </p>
                      </div>
                    </div>
                    <div className="text-right">
                      <div className="flex items-center gap-1 text-accent">
                        <Icon name="Clock" size={16} />
                        <span className="font-accent text-sm">{area?.responseTime}</span>
                      </div>
                      <p className="font-body text-xs text-muted-foreground">Response Time</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-accent/10 border border-accent/20 rounded-xl p-6 md:p-8">
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0">
                  <Icon name="Zap" size={32} color="var(--color-accent)" />
                </div>
                <div>
                  <h4 className="font-headline font-semibold text-lg text-foreground mb-3">
                    24/7 Emergency Service
                  </h4>
                  <p className="font-body text-sm text-muted-foreground mb-4">
                    Electrical emergencies don't wait for business hours. We provide round-the-clock emergency response across all service areas with rapid dispatch and expert diagnosis.
                  </p>
                  <ul className="space-y-2 mb-6">
                    {[
                      "Immediate phone consultation",
                      "Rapid emergency dispatch",
                      "Fully equipped service vehicles",
                      "Expert fault diagnosis",
                      "Same-day emergency repairs"
                    ]?.map((item, index) => (
                      <li key={index} className="flex items-center gap-2 font-body text-sm text-foreground">
                        <Icon name="Check" size={16} color="var(--color-success)" />
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                  <button
                    onClick={handleEmergencyCall}
                    className="w-full flex items-center justify-center gap-2 px-6 py-3 bg-accent text-accent-foreground rounded-lg font-accent hover:bg-accent/90 transition-colors emergency-cta"
                  >
                    <Icon name="Phone" size={20} />
                    <span>Emergency: 082 793 5785</span>
                  </button>
                </div>
              </div>
            </div>

            <div className="bg-card border border-border rounded-xl p-6">
              <h4 className="font-headline font-semibold text-base text-foreground mb-4">
                Service Commitment
              </h4>
              <div className="grid grid-cols-2 gap-4">
                <div className="text-center p-4 bg-muted rounded-lg">
                  <div className="font-headline font-bold text-2xl text-primary mb-1">30+</div>
                  <div className="font-body text-xs text-muted-foreground">Years Experience</div>
                </div>
                <div className="text-center p-4 bg-muted rounded-lg">
                  <div className="font-headline font-bold text-2xl text-primary mb-1">24/7</div>
                  <div className="font-body text-xs text-muted-foreground">Availability</div>
                </div>
                <div className="text-center p-4 bg-muted rounded-lg">
                  <div className="font-headline font-bold text-2xl text-primary mb-1">500+</div>
                  <div className="font-body text-xs text-muted-foreground">Projects Completed</div>
                </div>
                <div className="text-center p-4 bg-muted rounded-lg">
                  <div className="font-headline font-bold text-2xl text-primary mb-1">&lt;60</div>
                  <div className="font-body text-xs text-muted-foreground">Min Response</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceAreaMap;